/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClaimEvidenceControllerFindOneQueryResponse, ClaimEvidenceControllerFindOnePathParams, ClaimEvidenceControllerFindOneQueryParams, ClaimEvidenceControllerFindOne400, ClaimEvidenceControllerFindOne401, ClaimEvidenceControllerFindOne403, ClaimEvidenceControllerFindOne404 } from "../../models/checklistsController/ClaimEvidenceControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { claimEvidenceControllerFindOne } from "../../clients/checklistsService/claimEvidenceControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const claimEvidenceControllerFindOneQueryKey = (id: ClaimEvidenceControllerFindOnePathParams["id"], params: ClaimEvidenceControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-application-claim-evidence/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ClaimEvidenceControllerFindOneQueryKey = ReturnType<typeof claimEvidenceControllerFindOneQueryKey>;
export function claimEvidenceControllerFindOneQueryOptions(id: ClaimEvidenceControllerFindOnePathParams["id"], params?: ClaimEvidenceControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = claimEvidenceControllerFindOneQueryKey(id, params);
  return queryOptions<ClaimEvidenceControllerFindOneQueryResponse, ResponseErrorConfig<ClaimEvidenceControllerFindOne400 | ClaimEvidenceControllerFindOne401 | ClaimEvidenceControllerFindOne403 | ClaimEvidenceControllerFindOne404>, ClaimEvidenceControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return claimEvidenceControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific claim evidence row by ID
 * {@link /api/v1/checklist-application-claim-evidence/:id}
 */
export function useClaimEvidenceControllerFindOne<TData = ClaimEvidenceControllerFindOneQueryResponse, TQueryData = ClaimEvidenceControllerFindOneQueryResponse, TQueryKey extends QueryKey = ClaimEvidenceControllerFindOneQueryKey>(id: ClaimEvidenceControllerFindOnePathParams["id"], params?: ClaimEvidenceControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ClaimEvidenceControllerFindOneQueryResponse, ResponseErrorConfig<ClaimEvidenceControllerFindOne400 | ClaimEvidenceControllerFindOne401 | ClaimEvidenceControllerFindOne403 | ClaimEvidenceControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? claimEvidenceControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...claimEvidenceControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimEvidenceControllerFindOne400 | ClaimEvidenceControllerFindOne401 | ClaimEvidenceControllerFindOne403 | ClaimEvidenceControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}